import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import EarlyAccessDialog from './EarlyAccessDialog';
import { isEarlyAccess } from './releaseState';
import { ROUTES } from './routes';
import { needsEarlyAccessAcknowledgement } from './userProfile';

export default function EarlyAccessGate() {
  const { authState, acknowledgeEarlyAccess } = useAuth();
  const [open, setOpen] = useState(false);
  const [acknowledgementError, setAcknowledgementError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const shouldOpen = Boolean(
      authState.user &&
      !authState.profileLoading &&
      isEarlyAccess() &&
      needsEarlyAccessAcknowledgement(authState.profile),
    );

    setOpen(shouldOpen);
  }, [authState.user, authState.profile, authState.profileLoading]);

  if (!authState.user || !isEarlyAccess()) {
    return null;
  }

  const handleContinue = async () => {
    try {
      await acknowledgeEarlyAccess();
      setAcknowledgementError('');
      setOpen(false);
    } catch (error) {
      console.error(error);
      setAcknowledgementError(
        'JourneyBot could not save this acknowledgement right now. You can continue using the app, but this notice may appear again after reload.',
      );
      setOpen(false);
    }
  };

  return (
    <EarlyAccessDialog
      open={open}
      onContinue={handleContinue}
      onDetails={() => navigate(ROUTES.earlyAccess)}
      error={acknowledgementError}
    />
  );
}
